import React, { useState, useRef, useEffect } from "react";
import Map from "./Map";
import { Image } from "semantic-ui-react";

const MapWithPopupWrapper = ({ data }) => {
  const containerRef = useRef(null);
  const popupRef = useRef(null);
  const [popup, setPopup] = useState({ visible: false, index: null, x: 0, y: 0 });

  const images = {
    1: data.img_1,
    2: data.img_2,
    3: data.img_3,
  };
  const titles = {
    1: data.title_1,
    2: data.title_2,
    3: data.title_3,
  };
  const links = {
    1: data.link_1,
    2: data.link_2,
    3: data.link_3,
  };

  const handleMarkerClick = (e, index) => {
    const marker = e.target.getBoundingClientRect();
    const container = containerRef.current.getBoundingClientRect();
    setPopup({
      visible: true,
      index,
      x: marker.left - container.left + marker.width / 2,
      y: marker.top - container.top ,
    });
  };

  const closePopup = () => setPopup({ visible: false, index: null, x: 0, y: 0 });

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (popupRef.current && !popupRef.current.contains(e.target)) {
        closePopup();
      }
    };
    if (popup.visible) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [popup.visible]);

  const handlePopupClick = () => {
/*     closePopup();
 */    const linkId = links[popup.index];
    if (linkId) document.getElementById(linkId)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div ref={containerRef} style={{ position: "relative" }}>
      <Map onMarkerClick={handleMarkerClick} />
      {popup.visible && (
        <div
          ref={popupRef}
          className="popup"
          onClick={handlePopupClick}
          style={{
            position: "absolute",
            top: popup.y,
            left: popup.x,
            background: "#fff",
            border: "1px solid #ccc",
            padding: 10,
            zIndex: 1000,
            cursor: "pointer",
          }}
        >
          {images[popup.index] && (
            <Image
              src={`${images[popup.index]["@id"]}/${images[popup.index].image_scales.image[0].scales.mini.download}`}
              alt={`Marker ${popup.index}`}
            />
          )}
          {titles[popup.index] && <p>{titles[popup.index]}</p>}
        </div>
      )}
    </div>
  );
};

export default MapWithPopupWrapper;
